<template>
  <div
    :class="{ hidden: !open, block: open }"
    class="fixed inset-x-0 bottom-0 z-20 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
  >
    <div
      :class="{ hidden: !open, block: open }"
      class="fixed inset-0 transition-opacity"
    >
      <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
    </div>

    <div
      :class="{ hidden: !open, block: open }"
      class="px-4 pt-5 pb-4 overflow-hidden transition-all transform bg-white rounded-lg shadow-xl sm:max-w-lg sm:w-full sm:p-6"
    >
      <div>
        <div
          class="flex items-center justify-center w-12 h-12 mx-auto bg-green-100 rounded-full"
        >
          <svg
            class="w-6 h-6 text-green-600"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              fill-rule="evenodd"
              d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </div>
        <div class="mt-3 sm:mt-5">
          <div class="mt-2">
            <p class="text-sm leading-5 text-gray-500">
              <v-select
                v-model="appointment.record_id"
                :options="Object.values(records)"
                :reduce="(record) => record.id"
                label="name"
                :appendToBody="true"
                class="block w-full mt-1 transition duration-150 ease-in-out bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
              />
            </p>
            <div
              class="grid grid-cols-6 gap-3 mt-3 text-sm leading-5 text-gray-500"
            >
              <div class="col-span-6 sm:col-span-2">
                <label
                  for="date"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Data</label
                >
                <flat-pickr
                  id="date"
                  v-model="appointment.date"
                  :config="date_config"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                >
                </flat-pickr>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label
                  for="start"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Inizio</label
                >
                <flat-pickr
                  id="start"
                  v-model="appointment.start"
                  :config="time_config"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                >
                </flat-pickr>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label
                  for="end"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Fine</label
                >
                <flat-pickr
                  id="end"
                  v-model="appointment.end"
                  :config="time_config"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                >
                </flat-pickr>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
      >
        <span class="flex w-full rounded-md shadow-sm sm:col-start-2">
          <button
            @click="$emit('save')"
            type="button"
            :disabled="!appointment.record_id"
            :class="{ 'opacity-50 cursor-not-allowed': !appointment.record_id }"
            class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo sm:text-sm sm:leading-5"
          >
            Salva
          </button>
        </span>
        <span
          class="flex w-full mt-3 rounded-md shadow-sm sm:mt-0 sm:col-start-1"
        >
          <button
            @click="$emit('dismiss')"
            type="button"
            class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline sm:text-sm sm:leading-5"
          >
            Annulla
          </button>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { Italian } from "flatpickr/dist/l10n/it";

export default {
  props: ["open", "appointment"],
  data: () => {
    return {
      date_config: {
        altFormat: "d/m/Y",
        altInput: true,
        dateFormat: "Y-m-d",
        locale: Italian,
        allowInput: true,
      },
      time_config: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        minDate: "09:00",
        maxDate: "20:00",
        allowInput: true,
      },
    };
  },
  computed: {
    ...mapState("record", ["records"]),
  },
};
</script>
